export default {
  name: 'it',
  data: {
    modal: {
      cancel: 'Cancella',
      confirm: 'OK'
    },
    pagination: {
      prev: 'Precedente',
      next: 'Successiva'
    },
    select: {
      empty: 'Nessun Dato... \\[ o_x ]/'
    },
    table: {
      empty: 'Nessun Dato... \\[ o_x ]/'
    }
  }
}